import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./init";
import { reducers } from "./reducers";

export const confirmSlice = createSlice({
  name: "confirm",
  initialState,
  reducers,
});

